import {
  AddProcurementPurchaseRequestCommentDocument,
  CommentsCommentFragment,
  PurchaseRequestDetailDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import CommentsContainer from 'modules/comments/components/CommentsContainer'
import { CommentsCommentValues } from 'modules/comments/components/CommentsContainer/CommentEditor'

interface Props {
  comments: CommentsCommentFragment[]
  purchaseRequestId: number
}

const Comments = ({ comments, purchaseRequestId }: Props) => {
  const [addComment] = useMutation(AddProcurementPurchaseRequestCommentDocument, {
    extractorFn: (data) => data.procurementMutations.createCommentProcurementPurchaseRequest,
  })

  const handleAddComment = (variables: CommentsCommentValues) => {
    return addComment({
      variables,
      refetchQueries: [PurchaseRequestDetailDocument],
      awaitRefetchQueries: true,
    })
  }

  return (
    <CommentsContainer
      noPadding
      totalCount={comments.length}
      comments={comments}
      onAddComment={handleAddComment}
      resourceId={purchaseRequestId}
    />
  )
}

export default Comments
